<template>
	<el-config-provider :locale="zhCn">
		<router-view />
	</el-config-provider>
</template>
<script setup>
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import { onMounted } from 'vue';
import { sendConvertData } from '@/utils/api.js'
import { useRoute } from 'vue-router';
let route = useRoute();
console.log(route)
onMounted(()=>{
	info();
})
const info = () =>{
	setTimeout( async()=>{
		console.log(111111200000022222,route.query)
		console.log(111111200000022222,route.query.bd_vid)
		if(route.query.bd_vid){
			localStorage.setItem('bd_vid', route.query.bd_vid);
			let res = await sendConvertData(route.query);
		}else{
		  localStorage.setItem('bd_vid', '');
		}
	},1000)
}
</script>
<style lang="scss">
html,
body {
	margin: 0;
	padding: 0;
	height: 100%;
	background-color: #f0f0f0; /* 设置背景色为浅灰色 */
	position: relative;
	z-index: -2;
}
</style>
